import React from 'react';
import LazyComponent from '../components/common/LazyComponent';

// Lazily load components
const ClientDashboard = React.lazy(() => import('../components/ClientDashboard'));

/**
 * View component for login/dashboard page
 */
const LoginView: React.FC = () => {
  return (
    <LazyComponent>
      <ClientDashboard />
    </LazyComponent>
  );
};

export default LoginView; 